"use client"

import { BaseLayout } from "@/components"
import { Redirect } from "@/components/utils"

export default function IndexPage() {
  return (
    <BaseLayout>
      <Redirect to="/profile" />
    </BaseLayout>
  )
}
